import React from "react";
import {ResultTray} from "../../../services/interface/trays/result-tray";
import {useTranslation} from "react-i18next";
import {CheckCircleRounded, UnpublishedRounded} from "@mui/icons-material";
import Simulator from "./Simulator";

type InfoRateType = 'normal' | 'result';

interface Props {
    result?: ResultTray
}
export default function Qualification({result}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    function InfoRate({color, label, value, type}: {color?: string; label: string, value: string | number, type: InfoRateType}) {
        return(
            <div className={'flex flex-col bg-gray-200 rounded-[4px] p-0'}>
                <div className={`${color ? color : 'bg-empColorSecondary'} rounded-t-[4px] text-white font-semibold uppercase text-[11px] flex px-2 items-center`}>{label}</div>
                <div className={`ml-auto mt-auto mr-1 font-semibold ${type === 'normal' ? 'text-[14px]' : 'text-[22px]'}`}>{value}</div>
            </div>
        )
    }

    function InfoResult(label: string, value: string | number, check: boolean) {
        const styleCheck = 'uppercase text-[13px] font-semibold gap-1 flex items-center text-header'

        return(
            <div className={'flex flex-col gap-1'}>
                <div className={'flex flex-row justify-center'}>
                    {check ?
                        <div className={`${styleCheck}`}><CheckCircleRounded className={'text-success'}/>{t('meets')}
                        </div> :
                        <div className={`${styleCheck}`}><UnpublishedRounded className={'text-red-600'}/>{t('fails')}
                        </div>
                    }
                </div>
                <div className={'grid grid-cols-2 bg-gray-200 rounded-[4px] p-0 gap-4'}>
                    <div
                        className={`flex items-center justify-center rounded-[4px] p-2 ${check ? 'bg-success' : 'bg-red-600'} text-white font-semibold uppercase text-[11px]`}>{label}</div>
                    <div className={'flex items-center text-header font-semibold text-[14px]'}>{value}</div>
                </div>
            </div>
        )
    }

    return (
        <>
            <div className={'flex flex-col gap-4 custom-card px-4 pt-4'}>
                <div className={`flex flex-col gap-2 sm:flex-row`}>
                    <div className={'w-full lg:w-[70%] grid gap-6'}>
                        <div className={'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'}>
                            <InfoRate color={'bg-headerMenus'} label={t('financing-rate')} value={'15.60%'} type={'normal'}/>
                            <InfoRate color={'bg-headerMenus'} label={t('value-finance')} value={'$7909.07'} type={'normal'}/>
                            <InfoRate color={'bg-headerMenus'} label={t('cash-payment')} value={'$8000.00'} type={'normal'}/>
                            <InfoRate color={'bg-headerMenus'} label={t('credit-quota')} value={'$256.00'} type={'normal'}/>
                            <InfoRate color={'bg-headerMenus'} label={t('final-installment')} value={'$326.27'} type={'normal'}/>
                        </div>
                        <div className={'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'}>
                            <InfoRate color={'bg-headerMenus'} label={t('product-quota')} value={'$273.00'} type={'result'}/>
                            <InfoRate color={'bg-headerMenus'} label={t('minimum-credit-rate')} value={'13.50%'} type={'result'}/>
                        </div>
                    </div>
                    <div className={'w-full lg:w-[30%]'}>
                        <Simulator/>
                    </div>
                </div>
                <div className={'flex flex-col gap-6 py-4 border border-t-secondary border-transparent'}>
                    <div className={'ml-auto w-full lg:w-[50%] grid grid-cols-2 gap-6'}>
                        <InfoRate label={t('estimated-monthly-income')} value={'$650.20'} type={'normal'}/>
                        <InfoRate label={t('monthly-expenses')} value={'$300.00'} type={'normal'}/>
                    </div>
                </div>
                {/*<div className={'grid grid-cols-1 md:grid-cols-3 gap-6 px-6'}>*/}
                {/*    {InfoResult(t('entrance'), '53.33%', true)}*/}
                {/*    {InfoResult(t('operation-term'), '36 meses', false)}*/}
                {/*    {InfoResult(t('safe-term'), '36 meses', true)}*/}
                {/*</div>*/}
            </div>
        </>
    )
}
